app.factory('appFactory', ['$http', '$log', '$q',
    function ($http, $log, $q) {

    return {
        getData: function (url,responseType) {
            var deferred = $q.defer();
            $http({
                method: 'GET',
                url: url,
                cache: false,
                responseType: responseType,
            }).then(function (data) {
                deferred.resolve(data);
            }, function (error) {
                Swal.fire(
                    "Failed",
                    "There is a problem connecting to the server. \
                    Please ensure your internet connection is active. If the problem persists, please try again later.",
                    "error"
                )
                deferred.reject(error);
                $log.error(error);
            });
            return deferred.promise;
        },
        getDataByID: function (url, id) {
            var deferred = $q.defer();
            $http({
                method: 'GET',
                url: url + id,
                cache: false,
            }).then(function (data) {
                deferred.resolve(data);
            }, function (error) {
                deferred.reject(error);
                $log.error(error);
            });
            return deferred.promise;
        },
        postGetData: function (url, method, data) {
            var deferred = $q.defer();
            $http({
                method: method,
                url: url,
                data: data
            }).then(function (data) {
                deferred.resolve(data);
            }, function (error) {
                Swal.fire(
                    "Failed",
                    "There is a problem connecting to the server. \
                    Please ensure your internet connection is active. If the problem persists, please try again later.",
                    "error"
                )
                deferred.reject(error);
                $log.error(error);
            });
            return deferred.promise;
        },
    }
}]);